import { Injectable } from '@angular/core';
import { MasterApi } from '@shared/apis/master.api';
import { AuthApi } from '@shared/apis/auth.api';
import { UserApi } from '@shared/apis/user.api';
import { TicketApi } from '@shared/apis/ticket.api';
import { BpApi } from '@shared/apis/bp.api';
import { ProductApi } from '@shared/apis/product.api';
import { DealerApi } from '@shared/apis/dealer.api';
import { Sc4uApi } from '@shared/apis/sc4u.api';
import { LocatorApi } from '@shared/apis/locator.api';
import { CompanyApi } from '@shared/apis/company.api';
import { PortalApi } from '@shared/apis/portal.api';
import { SummaryApi } from '@shared/apis/summary.api';
import { ConcealedDamageApi } from '@shared/apis/concealed-damage.api';
import { PurchasePlaceApi } from '@shared/apis/purchase-place.api';
import { AccessDataApi } from '@shared/apis/access-data.api';
import { SalesDataApi } from '@shared/apis/sales-data.api';
import { CaseApi } from '@shared/apis/case.api';
import { B2bTicketApi } from '@shared/apis/b2b-ticket.api';
import { RsmEscalationApi } from '@shared/apis/rsm-escalation.api';
import { ZipCodeApi } from '@shared/apis/zip-code.api';
import { ExtendSerialApi } from '@shared/apis/extend-serial.api';
import { InquiryApi } from '@shared/apis/inquiry.api';
import { TrainingVideoApi } from '@shared/apis/training-video.api';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(public auth: AuthApi,
              public master: MasterApi,
              public user: UserApi,
              public dealer: DealerApi,
              public summary: SummaryApi,
              public company: CompanyApi,
              public purchasePlace: PurchasePlaceApi,
              public bp: BpApi,
              public sc4u: Sc4uApi,
              public product: ProductApi,
              public concealedDamage: ConcealedDamageApi,
              public locator: LocatorApi,
              public portal: PortalApi,
              public ticket: TicketApi,
              public b2bTicket: B2bTicketApi,
              public caseApi: CaseApi,
              public accessData: AccessDataApi,
              public salesData: SalesDataApi,
              public rsmEscalation: RsmEscalationApi,
              public zipCode: ZipCodeApi,
              public extendSerial: ExtendSerialApi,
              public inquiry: InquiryApi,
              public trainingVideo: TrainingVideoApi) {
  }
}
